<script lang="ts" context="module">
  interface ICurrentScheduleRow {
    realWeekIndexes: number[];
    expectedWeekIndexes: number[];
    delayWeekIndexes: number[];
  }

  interface ICurrentScheduleWeek {
    index: number;
    number: number;
  }

  export interface ICurrentSchedule {
    currentWeek: ICurrentScheduleWeek;
    currentDelay: string;
    earliestWeek: ICurrentScheduleWeek;
    expectedDeliveryDate: string;
    latestWeek: ICurrentScheduleWeek;
    rows: ICurrentScheduleRow[];
  }

  export interface ISchedulePanel {
    currentSchedule: ICurrentSchedule | null;
    description: string;
    timeSchedulePageLink: {
      text: string;
      url: string;
    };
    title: string;
  }
</script>

<script>
  import { t } from "../../../core";
  import { link } from "../../../core";
  import AsideBlock from "../AsideBlock.svelte";
  import Chart from "./Chart.svelte";
  import Legend from "./Legend.svelte";

  export let schedulePanel: ISchedulePanel;
</script>

{#if schedulePanel}
  <AsideBlock title={schedulePanel?.title} iconName="schedule">
    <a
      use:link
      class="link"
      slot="subtitle"
      href={schedulePanel?.timeSchedulePageLink.url}
    >
      {schedulePanel?.timeSchedulePageLink.text}
    </a>

    <p class="mini-schedule-desc">
      {@html schedulePanel?.description}
    </p>

    {#if schedulePanel?.currentSchedule}
      <div class="mini-schedule-content">
        {#if schedulePanel.currentSchedule.rows.length > 0}
          <Chart currentSchedule={schedulePanel.currentSchedule} />
          <Legend />
        {/if}
      </div>

      <div class="mini-schedule-table">
        <div class="mini-schedule-table__row">
          <p class="mini-schedule-table__title">
            {t("SchedulePanel.Info.CurrentWeek")}
          </p>
          <p class="mini-schedule-table__info">
            {schedulePanel?.currentSchedule?.currentWeek?.number}
          </p>
        </div>
        {#if schedulePanel?.currentSchedule?.currentDelay}
          <div class="mini-schedule-table__row">
            <p class="mini-schedule-table__title">
              {t("SchedulePanel.Info.DelayWeek")}
            </p>
            <p class="mini-schedule-table__info">
              {schedulePanel.currentSchedule.currentDelay}
              {t("SchedulePanel.Info.DelayDays")}
            </p>
          </div>
        {/if}
        {#if schedulePanel?.currentSchedule?.expectedDeliveryDate}
          <div class="mini-schedule-table__row">
            <p class="mini-schedule-table__title">
              {t("SchedulePanel.Info.ExpectedDelivery")}
            </p>
            <p class="mini-schedule-table__info">
              {schedulePanel.currentSchedule.expectedDeliveryDate}
            </p>
          </div>
        {/if}
      </div>
    {:else}
      <p class="no-data-label">{t("General.Schedule.NoData")}</p>
    {/if}
  </AsideBlock>
{/if}

<style lang="scss">
  .mini-schedule-desc {
    @include small;
  }

  .mini-schedule-content {
    margin: 20px 0;
  }

  .mini-schedule-table {
    @include small;

    &__title {
      font-weight: 900;
    }

    &__row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 10px;
      margin-bottom: 4px;
    }
  }

  .no-data-label {
    margin-top: 20px;
  }
</style>
